import { Catalog, isNeeds } from '../../../models/catalogs.models'
import { useOutletContext } from 'react-router-dom'
import InventoryCheckPage from '../../../components/page/InventoryCheckLists.page'
import { MaterialType } from '../../../models/materials.models'

const CatalogInventoryCheckTab = ({...props}) => {
  const { catalog } = useOutletContext<{
    catalog: Catalog
  }>()

  return <InventoryCheckPage type={isNeeds(catalog.type) ? MaterialType.need : MaterialType.resource}  catalog={catalog}
 isInventoryCheck={true} {...props} />
}

export default CatalogInventoryCheckTab
